import mainRoutes from './routes/main';
import profileRoutes from './routes/profile';
import twoFactorRoutes from './routes/twoFactor';
import paymentSettingsRoutes from './routes/paymentSettings';
import subscriptionRoutes from './routes/subscription';
import selfEmployedRoutes from './routes/selfEmployed';
import partnershipRoutes from './routes/partnership';
import safeDealRoutes from './routes/safeDeal';
import streamerWidgetsRoutes from './routes/streamerWidgets';
import reportsRoutes from './routes/reports';
import ticketRoutes from './routes/ticket';

export default [
  ...mainRoutes,
  ...profileRoutes,
  ...twoFactorRoutes,
  ...paymentSettingsRoutes,
  ...subscriptionRoutes,
  ...selfEmployedRoutes,
  ...partnershipRoutes,
  ...safeDealRoutes,
  ...streamerWidgetsRoutes,
  ...reportsRoutes,
  ...ticketRoutes,
  {
    path: '*',
    redirect: {
      name: 'cabinet',
    },
  },
];
